<!--donor view-medical-->
<div class="donor-view" *ngIf="!isCampaigner()">
  <p class="this-fundraiser">This fundraiser is <span>‘Under Review’.</span> You can contribute if you trust the campaigner.</p>
</div>
<!--campaigner view unverfied banner-->
<div class="donor-view" *ngIf="isCampaigner() && Difference_In_Days > 7">
  <p>
    <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.70518 26.4995H26.2952C28.6052 26.4995 30.0452 23.9945 28.8902 21.9995L17.5952 2.48453C16.4402 0.489531 13.5602 0.489531 12.4052 2.48453L1.11018 21.9995C-0.0448181 23.9945 1.39518 26.4995 3.70518 26.4995ZM15.0002 15.9995C14.1752 15.9995 13.5002 15.3245 13.5002 14.4995V11.4995C13.5002 10.6745 14.1752 9.99953 15.0002 9.99953C15.8252 9.99953 16.5002 10.6745 16.5002 11.4995V14.4995C16.5002 15.3245 15.8252 15.9995 15.0002 15.9995ZM16.5002 21.9995H13.5002V18.9995H16.5002V21.9995Z" fill="#E82943"/>
    </svg>
    Your fundraiser is <span>‘Under Review’.</span> Please complete the
    <label class="verification-process-i">verification process<i class="material-icons">info</i>
      <ng-container *ngTemplateOutlet="popover"></ng-container>
    </label>
    immediately to continue fundraising. <a class="copy-link" (click)="completeVerification()">Complete Now</a>
  </p>
</div>
<div class="pre-approve-wrapper" *ngIf="isCampaigner() && Difference_In_Days <= 7">
  <div class="container">
    <h3 class="text-center">Congrats! Your fundraiser is now active and you can begin receiving contributions.</h3>
    <p class="text-center">Share this URL with your family, friends and well-wishers. <span>{{ fundraiserLink }}</span>
      <span (click)="copyLink()" class="copy-link style-as-link">COPY LINK</span>
    </p>
    <div class="share-btn">
      <app-fb-share [label]="isMobile ? 'Share' : 'Spread the Word'"  position="19"></app-fb-share>
      <app-whatsapp-share [label]="isMobile ? 'Share' : 'Share on Whatsapp'" position="18"></app-whatsapp-share>
    </div>
    <div class="under-review">
      <svg width="46" height="40" viewBox="0 0 46 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.42963 39.9996H40.5696C44.163 39.9996 46.403 36.1029 44.6063 32.9996L27.0363 2.64293C25.2396 -0.460404 20.7596 -0.460404 18.963 2.64293L1.39297 32.9996C-0.403702 36.1029 1.8363 39.9996 5.42963 39.9996ZM22.9996 23.6663C21.7163 23.6663 20.6663 22.6163 20.6663 21.3329V16.6663C20.6663 15.3829 21.7163 14.3329 22.9996 14.3329C24.283 14.3329 25.333 15.3829 25.333 16.6663V21.3329C25.333 22.6163 24.283 23.6663 22.9996 23.6663ZM25.333 32.9996H20.6663V28.3329H25.333V32.9996Z" fill="#039695"/>
      </svg>
      <p>
          Your fundraiser has been marked as <span>“Under Review”</span> and can only accept INR contributions until the verification process is complete.
          Complete verification within 7 days to avoid deactivation.
          <label class="verification-process-i go-to-manage-campaign" (click)="completeVerification()">
            Complete verification now
          </label>
          <label class="verification-process-i"><i class="material-icons">info</i>
            <ng-container *ngTemplateOutlet="popover"></ng-container>
          </label>
      </p>
    </div>
  </div>
</div>

<ng-template #popover>
    <div class="popover-content">
        <span>To complete verification process</span>
        <ol>
          <li>Upload your Aadhar/Passport</li>
          <li>Upload valid medical documents</li>
        </ol>
      </div>
</ng-template>